<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-drag-arrow`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M24.78 1.976a1 1 0 00-1.56 0l-5.92 7.4A1 1 0 0018.08 11H22v11H11v-3.92a1 1 0 00-1.625-.78l-7.399 5.92a1 1 0 000 1.56l7.4 5.92A1 1 0 0011 29.92V26h11v11h-3.92a1 1 0 00-.78 1.625l5.92 7.399a1 1 0 001.56 0l5.92-7.4A1 1 0 0029.92 37H26V26h11v3.92a1 1 0 001.625.78l7.399-5.92a1 1 0 000-1.56l-7.4-5.92a1 1 0 00-1.624.78V22H26V11h3.92a1 1 0 00.78-1.625l-5.92-7.399z"/></svg>
</template>
<script>

export default {
  name: 'IconDragArrow',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
